<div class="covers-exclusions">
  <ui-tabs
    (tabSelected)="handleTabSelection($event)"
    class="tab-view"
    *ngIf="displayAs === 'tabs'"
  >
    <ui-tab [title]="includedTitle">
      <ng-container *ngTemplateOutlet="whatIncluded" ;></ng-container>
    </ui-tab>
    <ui-tab [title]="excludedTitle" (click)="handleWhatsExcludedClick()">
      <ng-container *ngTemplateOutlet="whatExcluded" ;></ng-container>
    </ui-tab>
  </ui-tabs>
  <div *ngIf="displayAs === 'stacked'" class="stack-view">
    <h3>{{ includedTitle }}</h3>
    <ng-container *ngTemplateOutlet="whatIncluded" ;></ng-container>
    <h3>{{ excludedTitle }}</h3>
    <ng-container *ngTemplateOutlet="whatExcluded" ;></ng-container>
  </div>
  <div *ngIf="deviceExcluded" class="stack-view mt-6">
    <p class="text--center">{{ deviceExcluded }}</p>
  </div>
</div>

<ng-template #whatIncluded>
  <ul class="list" [ngClass]="{ 'mb-4 py-4': displayAs === 'stacked' }">
    <li
      class="list__item list__item"
      [ngClass]="customTickIcon ? '' : 'icon--md icon-large-tick'"
      *ngFor="let includedItem of included"
    >
      <div *ngIf="customTickIcon" class="icon--md icon-container mr-6">
        <img [src]="customTickIcon" />
      </div>
      {{ includedItem }}
    </li>
  </ul>
</ng-template>

<ng-template #whatExcluded>
  <ul class="list" [ngClass]="{ 'pt-4 whatExcluded': displayAs === 'stacked' }">
    <li
      class="list__item list__item"
      [ngClass]="customCrossIcon ? '' : 'icon-large-cross'"
      *ngFor="let excludedItem of excluded"
    >
      <div *ngIf="customCrossIcon" class="icon-container mr-6">
        <img [src]="customCrossIcon" />
      </div>
      {{ excludedItem }}
    </li>
  </ul>
</ng-template>
